/* eslint-disable */

import {
    ADD_DISTRICT,
    ADD_EXAM_SUBJECT_DATA,
    ADD_INSTITUTION_DATA,
    ADD_LOOKUP_OPTION,
    ADD_QUALIFICATION_SUBJECT,
    ADD_REQUISITION_DEPARTMENT_DATA,
    ADD_REQUISITIONPOST_DATA,
    ADD_SPECIALIZATION_DATA,
    ADD_STAGE,
    ADD_STATE_DATA,
    ADD_TALUKA,
    ADD_UNIVERSITY,
    ADD_VILLAGE,
    ADDDOCUMENTYPE,
    ADDQUALIFICATIONNAME,
    ADDQUALIFICATIONTYPE,
    ADMIN_UNIVERSITY_STATES,
    CONFIGURATION,
    EDIT_DISTRICT,
    EDIT_EXAM_SUBJECT_DATA,
    EDIT_INSTITUTION_DATA,
    EDIT_LOOKUP_OPTION,
    EDIT_QUALIFICATION_SUBJECT,
    EDIT_REQUISITION_DEPARTMENT_DATA,
    EDIT_REQUISITIONPOST_DATA,
    EDIT_SPECIALIZATION_DATA,
    EDIT_STAGE,
    EDIT_STATE_DATA,
    EDIT_TALUKA,
    EDIT_UNIVERSITY,
    EDIT_VILLAGE,
    EDITDOCUMENTYPE,
    EDITQUALIFICATIONNAME,
    EDITQUALIFICATIONTYPE,
    GET_ADMIN_GRIEVANCE_LIST,
    GET_ADMIN_GRIEVANCE_LIST_SEARCH_API,
    GET_ADMIN_GRIEVANCE_SINGLE_LIST,
    GET_ALL_DISTRICT,
    GET_ALL_DISTRICT_SEARCH,
    GET_ALL_EXAM_SUBJECTS,
    GET_ALL_INSTITUTION,
    GET_All_MODULES,
    GET_ALL_PARENT_LABELS, GET_ALL_PARENT_TYPE,
    GET_ALL_REQUISITION_DEPARTMENTS,
    GET_ALL_REQUISITIONPOST,
    GET_ALL_SPECIALIZATION,
    GET_ALL_STAGE_SEARCH, GET_ALL_STAGES,
    GET_ALL_STATES,
    GET_ALL_TALUKA,
    GET_ALL_TALUKA_SEARCH,
    GET_ALL_TYPES,
    GET_ALL_VILLAGE,
    GET_ALL_VILLAGE_SEARCH, GET_ALL_VILLAGE_SUBDIST,
    GET_DISTRICT, GET_DISTRICT_STATES,
    GET_EXAM_SUBJECT_BY_ID,
    GET_INSTITUTION,
    GET_INSTITUTION_ID,
    GET_LOOKUP_OPTION,
    GET_LOOKUP_OPTIONS,
    GET_NAVIGATION_SIDEBAR_API,
    GET_QUALIFICATION_SUBJECT,
    GET_REQUISITION_DEPARTMENT_BY_ID,
    GET_REQUISITION_DEPARTMENTS,
    GET_REQUISITIONPOST_BY_ID,
    GET_SPECIALIZATION_BY_ID,
    GET_STAGE_BY_ID,
    GET_STATE_BY_ID,
    GET_TALUKA,
    GET_TALUKA_DISTRICTS,
    GET_TALUKA_STATES,
    GET_UNIVERSITIES,
    GET_UNIVERSITY,
    GET_VILLAGE,
    GET_VILLAGE_DISTRICTS,
    GET_VILLAGE_STATES,
    GET_VILLAGE_TALUKAS,
    GETDOCUMENTTYPE,
    GETDOCUMENTTYPELIST,
    GETQUALIFICATION_NAME,
    GETQUALIFICATION_NAME_FOR_COMBO,
    GETQUALIFICATION_SUBJECTS,
    GETQUALIFICATION_TYPES,
    GETQUALIFICATION_TYPES_FOR_COMBO,
    GETQUALIFICATIONNAME,
    GETQUALIFICATIONTYPE,
    GETQUALIFICATIONTYPELIST,
    MANAGE_DISTRICT,
    MANAGE_EXAM_SUBJECT_DATA,
    MANAGE_INSTITUTION_DATA,
    MANAGE_LOOKUP_OPTION,
    MANAGE_QUALIFICATION_SUBJECT,
    MANAGE_REQUISITION_DEPARTMENT_DATA,
    MANAGE_REQUISITIONPOST_DATA,
    MANAGE_SPECIALIZATION_DATA,
    MANAGE_STAGE,
    MANAGE_STATE_DATA,
    MANAGE_TALUKA,
    MANAGE_UNIVERSITY,
    MANAGE_VILLAGE,
    MANAGEDOCUMENTYPE,
    MANAGEQUALIFICATIONNAME,
    MANAGEQUALIFICATIONTYPE,
    SEARCH_EXAM_SUBJECTS,
    SEARCH_INSTITUTION,
    SEARCH_REQUISITION_DEPARTMENT,
    SEARCH_REQUISITIONPOST,
    SEARCH_SPECIALIZATION,
    SEARCH_STATES,
    SEARCHDOCUMENTYPE,
    SEARCHQUALIFICATIONNAME,
    SEARCHQUALIFICATIONTYPE
} from "../../../common/constants/endpoints";

import {
    GET_GRIEVANCE_LIST_WITH_PAGINATION,
    SET_ADMIN_GRIEVANCE_SINGLE_LIST,
    SET_ADMIN_NAVIGATION_SIDEBAR_PANEL,
    SET_ADMIN_UNIVERSITY_STATES,
    SET_ALL_DISTRICT, SET_ALL_DISTRICT_PAGE_NO_COUNTER, SET_ALL_DISTRICT_STATES,
    SET_ALL_EXAMSUBJECT_PAGE_NO_COUNTER,
    SET_ALL_EXAMSUBJECTS,
    SET_ALL_INSTITUTION, SET_ALL_INSTITUTION_DROPDOWN, SET_ALL_INSTITUTION_PAGE_NO_COUNTER,
    SET_ALL_REQDEPARTMENT_PAGE_NO_COUNTER,
    SET_ALL_REQDEPARTMENTS,
    SET_ALL_REQUISITIONPOST, SET_ALL_REQUISITIONPOST_PAGE_NO_COUNTER,
    SET_ALL_SPECIALIZATION, SET_ALL_SPECIALIZATION_PAGE_NO_COUNTER,
    SET_ALL_STAGES,
    SET_ALL_STAGES_PAGE_NO_COUNTER,
    SET_ALL_STATES, SET_ALL_STATES_PAGE_NO_COUNTER,
    SET_ALL_TALUKA,
    SET_ALL_TALUKA_DISTRICTS,
    SET_ALL_TALUKA_PAGE_NO_COUNTER,
    SET_ALL_TALUKA_STATES,
    SET_ALL_VILLAGE,
    SET_ALL_VILLAGE_DISTRICTS,
    SET_ALL_VILLAGE_PAGE_NO_COUNTER,
    SET_ALL_VILLAGE_STATES,
    SET_ALL_VILLAGE_TALUKAS,
    SET_DISTRICT,
    SET_DOCUMENT_TYPE_PAGE_NO_COUNTER,
    SET_EXAMSUBJECT,
    SET_GET_ALL_DOCUMENTS_TYPE,
    SET_GET_ALL_QUALIFICATION_NAME,
    SET_GET_ALL_QUALIFICATION_TYPE,
    SET_GET_DOCUMENTS_TYPE,
    SET_GET_QUALIFICATION_NAME,
    SET_GET_QUALIFICATION_TYPE,
    SET_GUIDELINE_LINKS,
    SET_INSTITUTION,
    SET_LOOKUP_OPTION,
    SET_LOOKUP_OPTIONS,
    SET_LOOKUP_OPTIONS_PAGE_NO_COUNTER,
    SET_MODULES_LIST,
    SET_PARENT_EXAMSUBJECT_DATA,
    SET_PARENT_LABELS_LIST,
    SET_PARENT_LOOKUP_DATA,
    SET_PARENT_TYPE_LIST,
    SET_QUALIFICATION_NAME_PAGE_NO_COUNTER,
    SET_QUALIFICATION_NAMES,
    SET_QUALIFICATION_NAMES_COMBO,
    SET_QUALIFICATION_SUBJECT,
    SET_QUALIFICATION_SUBJECTS, SET_QUALIFICATION_SUBJECTS_PAGE_NO_COUNTER,
    SET_QUALIFICATION_TYPE_PAGE_NO_COUNTER,
    SET_QUALIFICATION_TYPES,
    SET_QUALIFICATION_TYPES_COMBO,
    SET_REPORT_RANGE,
    SET_REQDEPARTMENT,
    SET_REQUISITIONPOST,
    SET_SPECIALIZATION,
    SET_STAGE,
    SET_STATE,
    SET_TALUKA,
    SET_TYPES_LIST,
    SET_UNIVERSITIES, SET_UNIVERSITIES_PAGE_NO_COUNTER, SET_UNIVERSITY,
    SET_VILLAGE
} from '../../../common/constants/ActionTypes';
import API from '../../../helpers/API';

import { toastr } from 'react-redux-toastr';
import { hideLoader, showLoader } from "../../../common/actions/commonActions";

export const getDocumentTypeListPagination = (pageNumber, rowPerPage, searchText) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader())
            if (searchText != '' && searchText !== false && typeof (searchText) != "undefined") {
                response = await API.get(SEARCHDOCUMENTYPE + `/${pageNumber}` + `/${rowPerPage}` + `?&name=${searchText.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            } else {
                response = await API.get(GETDOCUMENTTYPELIST + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {
                dispatch({
                    type: SET_GET_ALL_DOCUMENTS_TYPE,
                    payload: response.data,
                });
                dispatch({
                    type: SET_DOCUMENT_TYPE_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
            }
            dispatch(hideLoader())
        } catch (error) {
            dispatch({
                type: SET_GET_ALL_DOCUMENTS_TYPE,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getDocumentType = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GETDOCUMENTTYPE + `?&id=${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_GET_DOCUMENTS_TYPE,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const addDocumentType = (requestBody, setViewDocumentTypeList, rowPerPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADDDOCUMENTYPE, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getDocumentTypeListPagination(0, rowPerPage));
            dispatch(resetDocumentType());
            setViewDocumentTypeList(true);
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const editDocumentType = (requestBody, setViewDocumentTypeList, rowPerPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(EDITDOCUMENTYPE, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getDocumentTypeListPagination(0, rowPerPage));
            dispatch(resetDocumentType());
            setViewDocumentTypeList(true);
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const manageDocumentType = (requestBody, rowPerPage, listCurrentPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGEDOCUMENTYPE, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let showPage = 0;
            if (listCurrentPage > 0) {
                showPage = listCurrentPage;
            }

            dispatch(getDocumentTypeListPagination(showPage, rowPerPage));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const resetDocumentType = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_GET_DOCUMENTS_TYPE,
            payload: {},
        });
    }
}

export const getQualificationTypeListPagination = (pageNumber, rowPerPage, searchText) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader())
            if (searchText != '' && searchText !== false && typeof (searchText) != "undefined") {
                response = await API.get(SEARCHQUALIFICATIONTYPE + `/${pageNumber}` + `/${rowPerPage}` + `?name=${searchText.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            } else {
                response = await API.get(GETQUALIFICATIONTYPELIST + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {
                dispatch({
                    type: SET_GET_ALL_QUALIFICATION_TYPE,
                    payload: response.data,
                });
                dispatch({
                    type: SET_QUALIFICATION_TYPE_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
            }
            dispatch(hideLoader())
        } catch (error) {
            dispatch({
                type: SET_GET_ALL_QUALIFICATION_TYPE,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getQualificationType = (typecode) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GETQUALIFICATIONTYPE + `?code=${typecode}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_GET_QUALIFICATION_TYPE,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const addQualificationType = (requestBody, setViewQualificationTypeList, rowPerPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADDQUALIFICATIONTYPE, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setViewQualificationTypeList(true);
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const editQualificationType = (requestBody, setViewQualificationTypeList, rowPerPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(EDITQUALIFICATIONTYPE, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setViewQualificationTypeList(true);
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const manageQualificationType = (requestBody, rowPerPage, listCurrentPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGEQUALIFICATIONTYPE, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let showPage = 0;
            if (listCurrentPage > 0) {
                showPage = listCurrentPage;
            }

            dispatch(getQualificationTypeListPagination(showPage, rowPerPage));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const resetQualificationType = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_GET_QUALIFICATION_TYPE,
            payload: {},
        });
    }
}

export const getQualificationNameListPagination = (pageNumber, rowPerPage, typeCode, searchText) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader())
            if (searchText != '' && searchText !== false && typeof (searchText) != "undefined") {
                response = await API.get(SEARCHQUALIFICATIONNAME + `/${pageNumber}` + `/${rowPerPage}` + `?typecode=${typeCode}` + `&namecode=${searchText.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else if (typeCode != '' && typeCode !== false && typeof (typeCode) != "undefined" && typeCode) {
                response = await API.get(SEARCHQUALIFICATIONNAME + `/${pageNumber}` + `/${rowPerPage}` + `?typecode=${typeCode}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            } else {
                response = await API.get(SEARCHQUALIFICATIONNAME + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {
                dispatch({
                    type: SET_GET_ALL_QUALIFICATION_NAME,
                    payload: response.data,
                });
                dispatch({
                    type: SET_QUALIFICATION_NAME_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
                dispatch(resetQualificationName());
            }
            dispatch(hideLoader())
        } catch (error) {
            dispatch({
                type: SET_GET_ALL_QUALIFICATION_NAME,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getQualificationName = (typecode) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GETQUALIFICATIONNAME + `/0/10` + `?namecode=${typecode}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_GET_QUALIFICATION_NAME,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const addQualificationName = (requestBody, setViewQualificationNameList, rowPerPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADDQUALIFICATIONNAME, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(resetQualificationName());
            setViewQualificationNameList(true);
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const editQualificationName = (requestBody, setViewQualificationNameList, rowPerPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(EDITQUALIFICATIONNAME, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            //dispatch(getQualificationNameListPagination(0,rowPerPage, '', ''));
            dispatch(resetQualificationName());
            setViewQualificationNameList(true);
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const manageQualificationName = (requestBody, rowPerPage, listCurrentPage, qualificationTypeCode, qualificationNameToSearch) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGEQUALIFICATIONNAME, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let showPage = 0;
            if (listCurrentPage > 0) {
                showPage = listCurrentPage;
            }

            dispatch(getQualificationNameListPagination(showPage, rowPerPage, qualificationTypeCode, qualificationNameToSearch));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const resetQualificationName = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_GET_QUALIFICATION_NAME,
            payload: {},
        });
    }
}

export const resetAllQualificationNameList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_GET_ALL_QUALIFICATION_NAME,
            payload: {},
        });
    }
}

export const getAllQualificationTypes = () => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            let response = await API.get(GETQUALIFICATION_TYPES, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: SET_QUALIFICATION_TYPES
                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Qualification Types:", errorMessage);
        }
    }
};

export const getQualificationNamesOfAType = (qualificationtypecode) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token
        try {
            let response = await API.get(GETQUALIFICATION_NAME + `?code=${qualificationtypecode}`, { headers: { 'Authorization': `Bearer ${token}` } });

            if (response && response.data && qualificationtypecode) {
                dispatch({
                    payload: response.data,
                    type: SET_QUALIFICATION_NAMES
                });
            } else {
                dispatch({
                    payload: {},
                    type: SET_QUALIFICATION_NAMES
                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Qualification Names:", errorMessage);
        }
    }
};

export const getAllQualificationTypesCombo = () => {
    return async (dispatch) => {
        try {
            let response = await API.get(GETQUALIFICATION_TYPES_FOR_COMBO);
            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: SET_QUALIFICATION_TYPES_COMBO
                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Qualification Types:", errorMessage);
        }
    }
};

export const getQualificationNamesOfATypeCombo = (qualificationtypecode) => {
    return async (dispatch) => {
        try {
            const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
            let token = session.jwtResponse && session.jwtResponse.token

            let response = await API.get(GETQUALIFICATION_NAME_FOR_COMBO + `?qualificationtypecode=${qualificationtypecode}`, { headers: { 'Authorization': `Bearer ${token}` } });

            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: SET_QUALIFICATION_NAMES_COMBO
                });
            }
        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Qualification Names:", errorMessage);
        }
    }
};

export const getQualSubjectTypeListPagination = (pageNumber, rowPerPage, qaulTypeNameCode, searchText) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader())
            if (searchText != '' && searchText !== false && typeof (searchText) != "undefined") {
                response = await API.get(GETQUALIFICATION_SUBJECTS + `/${pageNumber}` + `/${rowPerPage}` + `?namecode=${qaulTypeNameCode}` + `&name=${searchText.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            } else if (qaulTypeNameCode) {
                response = await API.get(GETQUALIFICATION_SUBJECTS + `/${pageNumber}` + `/${rowPerPage}` + `?namecode=${qaulTypeNameCode}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            } else {
                response = await API.get(GETQUALIFICATION_SUBJECTS + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {
                dispatch({
                    type: SET_QUALIFICATION_SUBJECTS,
                    payload: response.data,
                });
                dispatch({
                    type: SET_QUALIFICATION_SUBJECTS_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
                dispatch(resetQaulificationSubject());
            }
            dispatch(hideLoader())
        } catch (error) {
            dispatch({
                type: SET_QUALIFICATION_SUBJECTS,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const manageQaulSubjects = (requestBody, rowPerPage, listCurrentPage, qualificationSelectedNameCode, textToSearch) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_QUALIFICATION_SUBJECT, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let showPage = listCurrentPage;
            if (requestBody && requestBody.isDeleted == true || listCurrentPage < 0) {
                showPage = 0;
            }

            dispatch(getQualSubjectTypeListPagination(showPage, rowPerPage, qualificationSelectedNameCode, textToSearch));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const addQualificationSubject = (requestBody, setAddSubject, setQualificationNameCode, setTextToSearch) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADD_QUALIFICATION_SUBJECT, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(resetQaulificationSubject());
            setAddSubject({ "Mode": false });
            setQualificationNameCode(false);
            setTextToSearch(false);
            toastr.success(response.data.message);
        } catch (error) {

            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const editQualificationSubject = (requestBody, setAddSubject, setQualificationNameCode, setTextToSearch) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(EDIT_QUALIFICATION_SUBJECT, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetQaulificationSubject());
            setAddSubject({ "Mode": false });
            setQualificationNameCode(false);
            setTextToSearch(false);
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getQualificationSubject = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_QUALIFICATION_SUBJECT + `/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_QUALIFICATION_SUBJECT,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const resetQaulificationSubject = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_QUALIFICATION_SUBJECT,
            payload: {},
        });
    }
}

export const resetQaulificationSubjectList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_QUALIFICATION_SUBJECTS,
            payload: {},
        });
    }
}

export const resetQaulificationNamesList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_QUALIFICATION_NAMES,
            payload: {},
        });
    }
}

export const resetQaulificationNamesCombo = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_QUALIFICATION_NAMES_COMBO,
            payload: {},
        });
    }
}

export const getAllModulesList = () => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;

        try {
            let response = await API.get(GET_All_MODULES, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: SET_MODULES_LIST
                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Modules List:", errorMessage);
        }
    }
};

export const getAllTypesList = (modulecode) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token
        try {
            let response = await API.get(GET_ALL_TYPES + `?module=${modulecode}`, { headers: { 'Authorization': `Bearer ${token}` } });

            if (response && response.data && modulecode) {
                dispatch({
                    payload: response.data,
                    type: SET_TYPES_LIST
                });
            } else {
                dispatch({
                    payload: {},
                    type: SET_TYPES_LIST
                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Lookup Options :", errorMessage);
        }
    }
};

export const getAllParentLabelList = (modulecode, typecode) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token
        try {
            let response = await API.get(GET_ALL_PARENT_LABELS + `?module=${modulecode}` + `&type=${typecode}`, { headers: { 'Authorization': `Bearer ${token}` } });

            if (response && response.data && modulecode && typecode) {
                dispatch({
                    payload: response.data,
                    type: SET_PARENT_LABELS_LIST
                });


            } else {
                dispatch({
                    payload: {},
                    type: SET_PARENT_LABELS_LIST
                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Lookup Options :", errorMessage);
        }
    }
};

export const getAllParentTypeList = (modulecode) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token
        try {
            let response = await API.get(GET_ALL_PARENT_TYPE + `?module=${modulecode}` + `&type=`, { headers: { 'Authorization': `Bearer ${token}` } });

            if (response && response.data && modulecode) {
                dispatch({
                    payload: response.data,
                    type: SET_PARENT_TYPE_LIST
                });
            } else {
                dispatch({
                    payload: {},
                    type: SET_PARENT_TYPE_LIST
                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Lookup Options :", errorMessage);
        }
    }
};

export const getLookupOptionListPagination = (pageNumber, rowPerPage, moduleCode, typeCode, textToSearch) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader())
            if (textToSearch != '' && textToSearch !== false && typeof (textToSearch) != "undefined") {
                response = await API.get(GET_LOOKUP_OPTIONS + `/${pageNumber}` + `/${rowPerPage}` + `?module=${moduleCode}` + `&type=${typeCode}` + `&label=${textToSearch.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            } else {
                response = await API.get(GET_LOOKUP_OPTIONS + `/${pageNumber}` + `/${rowPerPage}` + `?module=${moduleCode}` + `&type=${typeCode}` + `&label=`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {
                dispatch({
                    type: SET_LOOKUP_OPTIONS,
                    payload: response.data,
                });
                dispatch({
                    type: SET_LOOKUP_OPTIONS_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
                dispatch(resetLookupOption());
            }
            dispatch(hideLoader())
        } catch (error) {
            dispatch({
                type: SET_LOOKUP_OPTIONS,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const manageLookupOptions = (requestBody, rowPerPage, listCurrentPage, moduleCode, typeSelectedCode, textToSearch) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_LOOKUP_OPTION, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let showPage = listCurrentPage;
            if (requestBody && requestBody.isDeleted == true || listCurrentPage < 0) {
                showPage = 0;
            }

            dispatch(getLookupOptionListPagination(showPage, rowPerPage, moduleCode, typeSelectedCode, textToSearch));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const addLookupOptionData = (requestBody, setAddLookupOption, setModuleCode, setTypeCode, setParentType, setParentId, setTextToSearch) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADD_LOOKUP_OPTION, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetLookupOption());
            dispatch(resetLookupTypeList());
            dispatch(resetLookupOptionList());
            setAddLookupOption({ "Mode": false });
            setModuleCode(false);
            setTypeCode(false);
            setParentType(false);
            setParentId(false);
            setTextToSearch(false);
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const editLookupOption = (requestBody, setAddLookupOption, setModuleCode, setTypeCode, setParentType, setParentId, setTextToSearch) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(EDIT_LOOKUP_OPTION, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetLookupOption());
            dispatch(resetLookupTypeList());
            dispatch(resetLookupOptionList());
            setAddLookupOption({ "Mode": false });
            setModuleCode(false);
            setTypeCode(false);
            setParentType(false);
            setParentId(false);
            setTextToSearch(false);
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getLookupOption = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_LOOKUP_OPTION + `?id=${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_LOOKUP_OPTION,
                payload: response.data,
            });

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getParentLookupOption = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_LOOKUP_OPTION + `?id=${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_PARENT_LOOKUP_DATA,
                payload: response.data,
            });

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const resetLookupOption = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_LOOKUP_OPTION,
            payload: {},
        });
    }
}

export const resetLookupOptionList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_LOOKUP_OPTIONS,
            payload: {},
        });
    }
}

export const resetLookupTypeList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_TYPES_LIST,
            payload: {},
        });
    }

}

// State related Methods
export const getStatesListPagination = (pageNumber, rowPerPage, searchText) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader())
            if (searchText != '' && searchText !== false && typeof (searchText) != "undefined") {
                response = await API.get(SEARCH_STATES + `/${pageNumber}` + `/${rowPerPage}` + `/${searchText.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else {
                response = await API.get(GET_ALL_STATES + `/${pageNumber}` + `/${rowPerPage}` + `/88`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {
                dispatch({
                    type: SET_ALL_STATES,
                    payload: response.data,
                });
                dispatch({
                    type: SET_ALL_STATES_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
                dispatch(resetState());
            }
            dispatch(hideLoader())
        } catch (error) {
            dispatch({
                type: SET_ALL_STATES,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getStateData = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_STATE_BY_ID + `/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_STATE,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const addStateData = (requestBody, setAddState, setStatesList) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADD_STATE_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetState());
            dispatch(resetStatesList());
            setAddState({ "Mode": false });
            setStatesList('');
            dispatch(getStatesListPagination(0, 10));
            toastr.success(response.data.message);

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const editStateData = (requestBody, setAddState, setStatesList) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(EDIT_STATE_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(resetState());
            dispatch(resetStatesList());
            setAddState({ "Mode": false });
            setStatesList('');
            dispatch(getStatesListPagination(0, 10));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const manageStateData = (requestBody, rowPerPage, listCurrentPage, textToSearch) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_STATE_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let showPage = 0;
            if (listCurrentPage > 0) {
                showPage = listCurrentPage;
            }

            dispatch(getStatesListPagination(showPage, rowPerPage, textToSearch));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const resetState = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_STATE,
            payload: {},
        });
    }
}

export const resetStatesList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_ALL_STATES,
            payload: {},
        });
    }
}

// University related Methods
export const getUniversityListPagination = (pageNumber, rowPerPage, universityState, searchText, qualificationnamecode) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader())

            if (searchText != '' && searchText !== false && typeof (searchText) != "undefined" && universityState != '' && universityState !== false && typeof (universityState) != "undefined") {
                response = await API.get(GET_UNIVERSITIES + `/${pageNumber}` + `/${rowPerPage}` + `?statecode=${universityState}` + `&name=${searchText.trim()}` + `&qualificationnamecode=`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else if (searchText != '' && searchText !== false && typeof (searchText) != "undefined") {
                response = await API.get(GET_UNIVERSITIES + `/${pageNumber}` + `/${rowPerPage}` + `?statecode=${universityState}` + `&name=${searchText.trim()}` + `&qualificationnamecode=`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else {
                response = await API.get(GET_UNIVERSITIES + `/${pageNumber}` + `/${rowPerPage}` + `?statecode=${universityState}` + `&name=` + `&qualificationnamecode=`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {
                dispatch({
                    type: SET_UNIVERSITIES,
                    payload: response.data,
                });
                dispatch({
                    type: SET_UNIVERSITIES_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
                dispatch(resetUniversity());
            }
            dispatch(hideLoader())
        } catch (error) {
            dispatch({
                type: SET_UNIVERSITIES,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const manageUniversities = (requestBody, rowPerPage, listCurrentPage, universityState, textToSearch, qualificationNameCode) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_UNIVERSITY, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let showPage = listCurrentPage;
            if (requestBody && requestBody.isDeleted == true || listCurrentPage < 0) {
                showPage = 0;
            }

            dispatch(getUniversityListPagination(showPage, rowPerPage, universityState, textToSearch, qualificationNameCode));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const addUniversityData = (requestBody, setAddUniversity, setUniversityState, setUniversityName, setUniversityCode, setQualificationNameCode) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADD_UNIVERSITY, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetUniversity());
            setAddUniversity({ "Mode": false });
            setUniversityState('');
            setQualificationNameCode('');
            setUniversityName('');
            setUniversityCode('');
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const editUniversity = (requestBody, setAddUniversity, setUniversityState, setUniversityName, setUniversityCode, setQualificationNameCode) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(EDIT_UNIVERSITY, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetUniversity());
            setAddUniversity({ "Mode": false });
            setUniversityState('');
            setQualificationNameCode('');
            setUniversityName('');
            setUniversityCode('');
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getUniversityData = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_UNIVERSITY + `/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_UNIVERSITY,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getAllUniversityStates = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            let countryId = 88;
            response = await API.get(ADMIN_UNIVERSITY_STATES + `/${countryId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let sortedStates = response.data.stateDtoList.sort((a, b) => a.name.localeCompare(b.name));
            dispatch({
                type: SET_ADMIN_UNIVERSITY_STATES,
                payload: sortedStates
                ,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const resetUniversity = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_UNIVERSITY,
            payload: {},
        });
    }
}

export const resetUniversityList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_UNIVERSITIES,
            payload: {},
        });
    }
}


// District related Methods
export const getDistrictListPagination = (pageNumber, rowPerPage, districtState, searchText) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader())

            if (searchText != '' && searchText !== false && typeof (searchText) != "undefined" && districtState != '' && districtState !== false && typeof (districtState) != "undefined") {
                response = await API.get(GET_ALL_DISTRICT_SEARCH + `/${pageNumber}` + `/${rowPerPage}` + `?statecode=${districtState}` + `&name=${searchText.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else if (districtState != '' && districtState !== false && typeof (districtState) != "undefined") {
                response = await API.get(GET_ALL_DISTRICT_SEARCH + `/${pageNumber}` + `/${rowPerPage}` + `?statecode=${districtState}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else if (searchText != '' && searchText !== false && typeof (searchText) != "undefined") {
                response = await API.get(GET_ALL_DISTRICT_SEARCH + `/${pageNumber}` + `/${rowPerPage}` + `?name=${searchText.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else {
                response = await API.get(GET_ALL_DISTRICT + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {
                dispatch({
                    type: SET_ALL_DISTRICT,
                    payload: response.data,
                });
                dispatch({
                    type: SET_ALL_DISTRICT_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
                dispatch(resetDistrict());
            }

            dispatch(hideLoader())


        } catch (error) {
            dispatch({
                type: SET_ALL_DISTRICT,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const manageDistrict = (requestBody, rowPerPage, listCurrentPage, districtState, textToSearch) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_DISTRICT, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let showPage = listCurrentPage;
            if (requestBody && requestBody.isDeleted == true || listCurrentPage < 0) {
                showPage = 0;
            }

            dispatch(getDistrictListPagination(showPage, rowPerPage, districtState, textToSearch));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const addDistrictData = (requestBody, setAddDistrict, setDistrictState, setDistrictName, setDistrictCode, setDivisionId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADD_DISTRICT, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetDistrict());
            setAddDistrict({ "Mode": false });
            setDistrictState('');
            setDistrictName('');
            setDistrictCode('');
            setDivisionId('');
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const editDistrict = (requestBody, setAddDistrict, setDistrictState, setDistrictName, setDistrictCode, setDivisionId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(EDIT_DISTRICT, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetDistrict());
            setAddDistrict({ "Mode": false });
            setDistrictState('');
            setDistrictName('');
            setDistrictCode('');
            setDivisionId('');
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getDistrictData = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_DISTRICT + `?districtcode=${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_DISTRICT,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getAllDistrictStates = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            let countryId = 88;
            response = await API.get(GET_DISTRICT_STATES + `/${countryId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_DISTRICT_STATES,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const resetDistrict = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_DISTRICT,
            payload: {},
        });
    }
}

export const resetDistrictList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_ALL_DISTRICT,
            payload: {},
        });
    }
}

// Tahsil related Methods
export const getTalukaListPagination = (pageNumber, rowPerPage, talukaDistrict, searchText) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader())

            if (searchText != '' && searchText !== false && typeof (searchText) != "undefined" && talukaDistrict != '' && talukaDistrict !== false && typeof (talukaDistrict) != "undefined") {
                response = await API.get(GET_ALL_TALUKA_SEARCH + `/${pageNumber}` + `/${rowPerPage}` + `?districtcode=${talukaDistrict}` + `&subdistrictname=${searchText.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else if (talukaDistrict != '' && talukaDistrict !== false && typeof (talukaDistrict) != "undefined") {
                response = await API.get(GET_ALL_TALUKA_SEARCH + `/${pageNumber}` + `/${rowPerPage}` + `?districtcode=${talukaDistrict}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else if (searchText != '' && searchText !== false && typeof (searchText) != "undefined") {
                response = await API.get(GET_ALL_TALUKA_SEARCH + `/${pageNumber}` + `/${rowPerPage}` + `?subdistrictname=${searchText.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else {
                response = await API.get(GET_ALL_TALUKA + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {
                dispatch({
                    type: SET_ALL_TALUKA,
                    payload: response.data,
                });
                dispatch({
                    type: SET_ALL_TALUKA_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
                dispatch(resetTaluka());
            }
            dispatch(hideLoader())

        } catch (error) {
            dispatch({
                type: SET_ALL_TALUKA,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const manageTaluka = (requestBody, rowPerPage, listCurrentPage, talukaDistrict, textToSearch) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_TALUKA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let showPage = listCurrentPage;
            if (requestBody && requestBody.isDeleted == true || listCurrentPage < 0) {
                showPage = 0;
            }

            dispatch(getTalukaListPagination(showPage, rowPerPage, talukaDistrict, textToSearch));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const addTalukaData = (requestBody, setAddTaluka, setTalukaState, setTalukaDistrict, setTalukaName, setTalukaCode) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;

        try {
            response = await API.post(ADD_TALUKA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetTaluka());
            setAddTaluka({ "Mode": false });
            setTalukaState(false);
            setTalukaName('');
            setTalukaCode('');
            setTalukaDistrict(false);
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const editTaluka = (requestBody, setAddTaluka, setTalukaState, setTalukaDistrict, setTalukaName, setTalukaCode) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(EDIT_TALUKA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(resetTaluka());
            setAddTaluka({ "Mode": false });
            setTalukaState(false);
            setTalukaName('');
            setTalukaCode('');
            setTalukaDistrict(false);
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getTalukaData = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_TALUKA + `/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_TALUKA,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getAllTalukaStates = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            let countryId = 88;
            response = await API.get(GET_TALUKA_STATES + `/${countryId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_TALUKA_STATES,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getAllTalukaDistricts = (statecode) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_TALUKA_DISTRICTS + `?statecode=${statecode}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_TALUKA_DISTRICTS,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const resetTaluka = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_TALUKA,
            payload: {},
        });
    }
}

export const resetTalukaList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_ALL_TALUKA,
            payload: {},
        });
    }
}

// Village related Methods
export const getVillageListPagination = (pageNumber, rowPerPage, villageTaluka, searchText) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader())

            if (searchText != '' && searchText !== false && typeof (searchText) != "undefined" && villageTaluka != '' && villageTaluka !== false && typeof (villageTaluka) != "undefined") {
                response = await API.get(GET_ALL_VILLAGE_SEARCH + `/${pageNumber}` + `/${rowPerPage}` + `?subdistcode=${villageTaluka}` + `&name=${searchText.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else if (villageTaluka != '' && villageTaluka !== false && typeof (villageTaluka) != "undefined") {
                response = await API.get(GET_ALL_VILLAGE_SUBDIST + `/${pageNumber}` + `/${rowPerPage}` + `?subdistcode=${villageTaluka}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else if (searchText != '' && searchText !== false && typeof (searchText) != "undefined") {
                response = await API.get(GET_ALL_VILLAGE_SEARCH + `/${pageNumber}` + `/${rowPerPage}` + `?name=${searchText.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else {
                response = await API.get(GET_ALL_VILLAGE + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {
                dispatch({
                    type: SET_ALL_VILLAGE,
                    payload: response.data,
                });
                dispatch({
                    type: SET_ALL_VILLAGE_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
                dispatch(resetVillage());
            }
            dispatch(hideLoader())

        } catch (error) {
            dispatch({
                type: SET_ALL_VILLAGE,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const manageVillage = (requestBody, rowPerPage, listCurrentPage, villageTaluka, textToSearch) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_VILLAGE, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let showPage = listCurrentPage;
            if (requestBody && requestBody.isDeleted == true || listCurrentPage < 0) {
                showPage = 0;
            }

            dispatch(getVillageListPagination(showPage, rowPerPage, villageTaluka, textToSearch));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const addVillageData = (requestBody, setAddVillage, setVillageState, setVillageDistrict, setVillageTaluka, setVillageName) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADD_VILLAGE, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetVillage());
            dispatch(resetVillageList());
            dispatch(resetVillageDistrictsList());
            dispatch(resetVillageTalukasList());
            setAddVillage({ "Mode": false });
            setVillageState(false);
            setVillageName('');
            setVillageDistrict('');
            setVillageTaluka('');
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const editVillage = (requestBody, setAddVillage, setVillageState, setVillageDistrict, setVillageTaluka, setVillageName) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(EDIT_VILLAGE, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetVillage());
            dispatch(resetVillageList());
            dispatch(resetVillageDistrictsList());
            dispatch(resetVillageTalukasList());
            setAddVillage({ "Mode": false });
            setVillageState(false);
            setVillageName('');
            setVillageDistrict('');
            setVillageTaluka('');
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getVillageData = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_VILLAGE + `?villagecode=${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_VILLAGE,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getAllVillageStates = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            let countryId = 88;
            response = await API.get(GET_VILLAGE_STATES + `/${countryId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_VILLAGE_STATES,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getAllVillageDistricts = (statecode) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_VILLAGE_DISTRICTS + `?statecode=${statecode}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_VILLAGE_DISTRICTS,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getAllVillageTalukas = (districtcode) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_VILLAGE_TALUKAS + `/${districtcode}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_VILLAGE_TALUKAS,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const resetVillage = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_VILLAGE,
            payload: {},
        });
    }
}

export const resetVillageList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_ALL_VILLAGE,
            payload: {},
        });
    }
}

export const resetVillageDistrictsList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_ALL_VILLAGE_DISTRICTS,
            payload: {},
        });
    }
}

export const resetVillageTalukasList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_ALL_VILLAGE_TALUKAS,
            payload: {},
        });
    }
}
// Exam Subjects related Methods
export const getExamSubjectsListPagination = (pageNumber, rowPerPage, searchText) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(hideLoader())

            if (searchText != '' && searchText !== false && typeof (searchText) != "undefined") {
                response = await API.get(SEARCH_EXAM_SUBJECTS + `/${pageNumber}` + `/${rowPerPage}` + `?name=${searchText.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else {
                response = await API.get(SEARCH_EXAM_SUBJECTS + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {
                dispatch({
                    type: SET_ALL_EXAMSUBJECTS,
                    payload: response.data,
                });
                dispatch({
                    type: SET_ALL_EXAMSUBJECT_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
                dispatch(resetState());
            }
            dispatch(hideLoader())

        } catch (error) {
            dispatch({
                type: SET_ALL_EXAMSUBJECTS,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getExamSubjectData = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_EXAM_SUBJECT_BY_ID + `?id=${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_EXAMSUBJECT,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getAllExamSubjectsData = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_EXAM_SUBJECTS, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_PARENT_EXAMSUBJECT_DATA,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const addExamSubjectData = (requestBody, setAddExamSubject, setExamSubjectName, setExamSubjectCode) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADD_EXAM_SUBJECT_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetExamSubject());
            dispatch(resetExamSubjectsList());
            setAddExamSubject({ "Mode": false });
            setExamSubjectName('');
            // setExamSubjectNameDvng('');
            setExamSubjectCode('');
            dispatch(getExamSubjectsListPagination(0, 10));
            toastr.success(response.data.message);

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const editExamSubjectData = (requestBody, setAddExamSubject, setExamSubjectName, setExamSubjectCode) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(EDIT_EXAM_SUBJECT_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(resetExamSubject());
            dispatch(resetExamSubjectsList());
            setAddExamSubject({ "Mode": false });
            setExamSubjectName('');
            // setExamSubjectNameDvng('');
            setExamSubjectCode('');
            dispatch(getExamSubjectsListPagination(0, 10));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const manageExamSubjectData = (requestBody, rowPerPage, listCurrentPage, textToSearch) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_EXAM_SUBJECT_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let showPage = 0;
            if (listCurrentPage > 0) {
                showPage = listCurrentPage;
            }

            dispatch(getExamSubjectsListPagination(showPage, rowPerPage, textToSearch));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const resetExamSubject = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_EXAMSUBJECT,
            payload: {},
        });
    }
}

export const resetExamSubjectsList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_ALL_EXAMSUBJECTS,
            payload: {},
        });
    }
}
// Stage related methods
export const getStageListPagination = (pageNumber, rowPerPage, searchText) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader())

            if (searchText != '' && searchText !== false && typeof (searchText) != "undefined") {
                response = await API.get(GET_ALL_STAGE_SEARCH + `/${pageNumber}` + `/${rowPerPage}` + `/${searchText.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else {
                response = await API.get(GET_ALL_STAGES + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            if (response) {
                dispatch({
                    type: SET_ALL_STAGES,
                    payload: response.data,
                });
                dispatch({
                    type: SET_ALL_STAGES_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
                dispatch(resetState());
            }
            dispatch(hideLoader())

        } catch (error) {
            dispatch({
                type: SET_ALL_STAGES,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getStageData = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_STAGE_BY_ID + `?id=${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_STAGE,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getAllStagesData = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_STAGES, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_STAGES,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const addStageData = (requestBody, setAddStage, setStageName, setStageDescription, setStageCode, setStageType, setStageUrl) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADD_STAGE, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetStage());
            dispatch(resetStageList());
            setAddStage({ "Mode": false });
            setStageName('');
            setStageDescription('');
            setStageCode('');
            setStageType('');
            setStageUrl('');
            dispatch(getStageListPagination(0, 10));
            toastr.success(response.data.message);

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const editStageData = (requestBody, setAddStage, setStageName, setStageDescription, setStageCode, setStageType, setStageUrl) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(EDIT_STAGE, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(resetStage());
            dispatch(resetStageList());
            setAddStage({ "Mode": false });
            setStageName('');
            setStageDescription('');
            setStageCode('');
            setStageType('');
            setStageUrl('');
            dispatch(getStageListPagination(0, 10));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const manageStageData = (requestBody, rowPerPage, listCurrentPage, textToSearch) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_STAGE, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let showPage = 0;
            if (listCurrentPage > 0) {
                showPage = listCurrentPage;
            }

            dispatch(getStageListPagination(showPage, rowPerPage, textToSearch));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const resetStage = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_STAGE,
            payload: {},
        });
    }
}

export const resetStageList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_ALL_STAGES,
            payload: {},
        });
    }
}
// Specialisation related Methods
export const getSpecialisationListPagination = (pageNumber, rowPerPage, searchText, instId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader())

            if (searchText != '' && searchText !== false && typeof (searchText) != "undefined") {
                response = await API.get(SEARCH_SPECIALIZATION + `/${pageNumber}` + `/${rowPerPage}` + `?name=${searchText.trim()}&reqinstid=${instId}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            } else if (instId) {
                response = await API.get(GET_ALL_SPECIALIZATION + `/${pageNumber}` + `/${rowPerPage}?reqinstid=${instId}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            } else {
                response = await API.get(GET_ALL_SPECIALIZATION + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {
                dispatch({
                    type: SET_ALL_SPECIALIZATION,
                    payload: response.data,
                });
                dispatch({
                    type: SET_ALL_SPECIALIZATION_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
                dispatch(resetState());
            }
            dispatch(hideLoader())

        } catch (error) {
            dispatch({
                type: SET_ALL_SPECIALIZATION,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getSpecialisationData = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_SPECIALIZATION_BY_ID + `?id=${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_SPECIALIZATION,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const addSpecialisationData = (requestBody, setAddSpecialisation, setSpecialisationName, setSpecialisationNameDvng) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADD_SPECIALIZATION_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetSpecialisation());
            dispatch(resetSpecialisationList());
            setAddSpecialisation({ "Mode": false });
            setSpecialisationName('');
            setSpecialisationNameDvng('');
            dispatch(getSpecialisationListPagination(0, 10));
            toastr.success(response.data.message);

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const editSpecialisationData = (requestBody, setAddSpecialisation, setSpecialisationName, setSpecialisationNameDvng) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(EDIT_SPECIALIZATION_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(resetSpecialisation());
            dispatch(resetSpecialisationList());
            setAddSpecialisation({ "Mode": false });
            setSpecialisationName('');
            setSpecialisationNameDvng('');
            dispatch(getSpecialisationListPagination(0, 10));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const manageSpecialisationData = (requestBody, rowPerPage, listCurrentPage, textToSearch, instId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_SPECIALIZATION_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let showPage = 0;
            if (listCurrentPage > 0) {
                showPage = listCurrentPage;
            }

            dispatch(getSpecialisationListPagination(showPage, rowPerPage, '', instId));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const resetSpecialisation = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_SPECIALIZATION,
            payload: {},
        });
    }
}

export const resetSpecialisationList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_ALL_SPECIALIZATION,
            payload: {},
        });
    }
}

// Requisition Post related Methods
export const getRequisitionPostListPagination = (pageNumber, rowPerPage, searchText) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader())

            if (searchText != '' && searchText !== false && typeof (searchText) != "undefined") {
                response = await API.get(SEARCH_REQUISITIONPOST + `/${pageNumber}` + `/${rowPerPage}` + `?name=${searchText.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else {
                response = await API.get(GET_ALL_REQUISITIONPOST + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {
                dispatch({
                    type: SET_ALL_REQUISITIONPOST,
                    payload: response.data,
                });
                dispatch({
                    type: SET_ALL_REQUISITIONPOST_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
                dispatch(resetState());
            }
            dispatch(hideLoader())

        } catch (error) {
            dispatch({
                type: SET_ALL_REQUISITIONPOST,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getRequisitionPostData = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_REQUISITIONPOST_BY_ID + `?id=${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_REQUISITIONPOST,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const addRequisitionPostData = (requestBody, setAddRequisitionPost, setRequisitionPostName, setRequisitionPostNameDvng) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADD_REQUISITIONPOST_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetRequisitionPost());
            dispatch(resetRequisitionPostList());
            setAddRequisitionPost({ "Mode": false });
            setRequisitionPostName('');
            // setRequisitionPostNameDvng('');
            dispatch(getRequisitionPostListPagination(0, 10));
            toastr.success(response.data.message);

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const editRequisitionPostData = (requestBody, setAddRequisitionPost, setRequisitionPostName, setRequisitionPostNameDvng) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(EDIT_REQUISITIONPOST_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(resetRequisitionPost());
            dispatch(resetRequisitionPostList());
            setAddRequisitionPost({ "Mode": false });
            setRequisitionPostName('');
            // setRequisitionPostNameDvng('');
            dispatch(getRequisitionPostListPagination(0, 10));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const manageRequisitionPostData = (requestBody, rowPerPage, listCurrentPage, textToSearch) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_REQUISITIONPOST_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let showPage = 0;
            if (listCurrentPage > 0) {
                showPage = listCurrentPage;
            }

            dispatch(getRequisitionPostListPagination(showPage, rowPerPage, textToSearch));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const resetRequisitionPost = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_REQUISITIONPOST,
            payload: {},
        });
    }
}

export const resetRequisitionPostList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_ALL_REQUISITIONPOST,
            payload: {},
        });
    }
}


// Requisition Department related Methods
export const getRequisitionDepartmentListPagination = (pageNumber, rowPerPage, searchText) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader())

            //  if(searchText && deptToSearch){
            //     response = await API.get(SEARCH_REQUISITION_DEPARTMENT+`/${pageNumber}`+`/${rowPerPage}`+`?name=${searchText.trim()}` +`?admdeptid=${deptToSearch.trim()}`, {
            //         headers: { Authorization: `Bearer ${token}` },
            //     });
            // }
            if (searchText != '' && searchText !== false && typeof (searchText) != "undefined") {
                response = await API.get(SEARCH_REQUISITION_DEPARTMENT + `/${pageNumber}` + `/${rowPerPage}` + `?name=${searchText.trim()}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            // else if(deptToSearch){
            //     response = await API.get(SEARCH_REQUISITION_DEPARTMENT+`/${pageNumber}`+`/${rowPerPage}`+`?admdeptid=${deptToSearch.trim()}`, {
            //         headers: { Authorization: `Bearer ${token}` },
            //     });
            // }
            else {
                response = await API.get(GET_ALL_REQUISITION_DEPARTMENTS + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {
                dispatch({
                    type: SET_ALL_REQDEPARTMENTS,
                    payload: response.data,
                });
                dispatch({
                    type: SET_ALL_REQDEPARTMENT_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
                dispatch(resetRequisitionDepartment());
            }
            dispatch(hideLoader())

        } catch (error) {
            dispatch({
                type: SET_ALL_REQDEPARTMENTS,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getRequisitionDepartmentData = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_REQUISITION_DEPARTMENT_BY_ID + `?id=${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_REQDEPARTMENT,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getAllRequisitionDepartmentData = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_REQUISITION_DEPARTMENTS, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_REQDEPARTMENTS,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const addRequisitionDepartmentData = (requestBody, setAddRequisitionDepartment, setRequisitionDepartmentName, setRequisitionDepartmentNameDvng) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADD_REQUISITION_DEPARTMENT_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetRequisitionDepartment());
            dispatch(resetRequisitionDepartmentList());
            setAddRequisitionDepartment({ "Mode": false });
            setRequisitionDepartmentName('');
            setRequisitionDepartmentNameDvng('');
            dispatch(getRequisitionDepartmentListPagination(0, 10));
            toastr.success(response.data.message);

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const editRequisitionDepartmentData = (requestBody, setAddRequisitionDepartment, setRequisitionDepartmentName, setRequisitionDepartmentNameDvng) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(EDIT_REQUISITION_DEPARTMENT_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(resetRequisitionDepartment());
            dispatch(resetRequisitionDepartmentList());
            setAddRequisitionDepartment({ "Mode": false });
            setRequisitionDepartmentName('');
            setRequisitionDepartmentNameDvng('');
            dispatch(getRequisitionDepartmentListPagination(0, 10));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const manageRequisitionDepartmentData = (requestBody, rowPerPage, listCurrentPage, textToSearch) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_REQUISITION_DEPARTMENT_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let showPage = 0;
            if (listCurrentPage > 0) {
                showPage = listCurrentPage;
            }

            dispatch(getRequisitionDepartmentListPagination(showPage, rowPerPage, textToSearch));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const resetRequisitionDepartment = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_REQDEPARTMENT,
            payload: {},
        });
    }
}

export const resetRequisitionDepartmentList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_ALL_REQDEPARTMENTS,
            payload: {},
        });
    }
}

//Institution Related Methods
export const getInstitutionListPagination = (pageNumber, rowPerPage, searchText, deptId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader())
            if (searchText != '' && searchText !== false && typeof (searchText) != "undefined") {
                response = await API.get(SEARCH_INSTITUTION + `/${pageNumber}` + `/${rowPerPage}` + `?name=${searchText.trim()}&reqdeptid=${deptId}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else if (deptId) {
                response = await API.get(GET_ALL_INSTITUTION + `/${pageNumber}` + `/${rowPerPage}?reqdeptid=${deptId}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            } else {
                dispatch({
                    type: SET_ALL_INSTITUTION,
                    payload: {},
                });
            }
            if (response) {
                dispatch({
                    type: SET_ALL_INSTITUTION,
                    payload: response.data,
                });
                dispatch({
                    type: SET_ALL_INSTITUTION_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
                dispatch(resetState());
            }
            dispatch(hideLoader())
        } catch (error) {
            dispatch({
                type: SET_ALL_INSTITUTION,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const getInstitutionData = (id) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_INSTITUTION_ID + `?id=${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_INSTITUTION,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const getAllInstitutationData = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_INSTITUTION, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                // type: SET_ALL_INSTITUTION,
                type: SET_ALL_INSTITUTION_DROPDOWN,
                payload: response.data.requisitionInstitutionList,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const addInstitutionData = (requestBody, setAddInstitution, setInstitutionName, setInstitutionNameDevnagari, setRequisitionDepartmentSearch) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADD_INSTITUTION_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetInstitution());
            dispatch(resetInstitutionList());
            setAddInstitution({ "Mode": false });
            setRequisitionDepartmentSearch('');
            setInstitutionName('');
            setInstitutionNameDevnagari('');
            dispatch(getInstitutionListPagination(0, 10));
            toastr.success(response.data.message);

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const editInstitutionData = (requestBody, setAddInstitution, setInstitutionName, setInstitutionNameDevnagari, setRequisitionDepartment, setRequisitionDepartmentSearch) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(EDIT_INSTITUTION_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch(resetInstitution());
            dispatch(resetInstitutionList());
            setAddInstitution({ "Mode": false });
            setRequisitionDepartmentSearch('')
            setInstitutionName('');
            setInstitutionNameDevnagari('');
            // setRequisitionDepartment('')
            dispatch(getInstitutionListPagination(0, 10));
            toastr.success(response.data.message);

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const manageInstitutionData = (requestBody, rowPerPage, listCurrentPage, textToSearch, deptId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_INSTITUTION_DATA, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let showPage = 0;
            if (listCurrentPage > 0) {
                showPage = listCurrentPage;
            }

            dispatch(getInstitutionListPagination(showPage, rowPerPage, textToSearch, deptId));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const resetInstitution = () => {
    return async (dispatch) => {
        dispatch({
            type: SET_INSTITUTION,
            payload: {},
        });
    }
}

export const resetInstitutionList = () => {
    return async (dispatch) => {
        dispatch({
            type: SET_ALL_INSTITUTION,
            payload: {},
        });
    }
}

// Grievance related function
export const getAllGrievanceListPagination = (pageNumber, rowPerPage, searchText) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;

        try {
            dispatch(showLoader())
            if (searchText != '' && searchText !== false && typeof (searchText) != "undefined") {
                response = await API.get(GET_ADMIN_GRIEVANCE_LIST_SEARCH_API + `?searchBy=${searchText.trim()}` + `&page=${pageNumber}` + `&size=${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            } else {
                response = await API.get(`${GET_ADMIN_GRIEVANCE_LIST}/${pageNumber}/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            dispatch({
                type: GET_GRIEVANCE_LIST_WITH_PAGINATION,
                payload: response.data
            })
            dispatch(hideLoader())
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}
export const getSingleGrievance = (id) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            dispatch(showLoader())

            const response = await API.get(`${GET_ADMIN_GRIEVANCE_SINGLE_LIST}/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ADMIN_GRIEVANCE_SINGLE_LIST,
                payload: response.data
            })
            dispatch(hideLoader())

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}
export const handleSendRemark = (id, remark, setGrievanceResponse) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            const response = await API.post(`${GET_ADMIN_GRIEVANCE_SINGLE_LIST}`, { id, remark }, {
                headers: { Authorization: `Bearer ${token}` },

            });
            toastr.success(response.data.message);
            setGrievanceResponse(false)
            // dispatch({
            //     type: SET_ADMIN_GRIEVANCE_SINGLE_LIST,
            //     payload: response.data
            // })
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}



export const getAllSideBar = () => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            const result = await API.get(GET_NAVIGATION_SIDEBAR_API, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({ type: SET_ADMIN_NAVIGATION_SIDEBAR_PANEL, payload: result.data });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const getReportRange = () => {
    return async (dispatch) => {
        dispatch(showLoader());
        try {
            let response = await API.get(CONFIGURATION + `?type=OTHER` + `&key=RangeValue`);
            if (response && response.data) {
                let responseData = response.data[0].value;
                dispatch({
                    type: SET_REPORT_RANGE,
                    payload: responseData,
                });
            }
            if (response != null) {
                dispatch(hideLoader());
            }
        } catch (error) {
            dispatch(hideLoader());
            if (error && error.response) {
                let errorMessage =
                    error && error.response && error.response.data
                        ? error.response.data.message
                        : error.message;
                toastr.error(errorMessage);
                return;
            }
        }
    };
};